"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "torre-di-santa-maria": {
    "61c5c13f": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "basci": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dc84f2ba": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "conti": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f182725": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "foiani": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0315596c": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "gianni": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aad1aba5": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "luna": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "096eb71f": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "musci": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "87174365": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "pizzi": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7103f76f": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "prato": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "873fa64b": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "scaia": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5a5df705": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "spineda": [{
      "hkey": "4653d3b0",
      "slug": "torre-di-santa-maria",
      "name": "Torre di Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;